import React, { Component } from 'react';
import popup from '~/views/Popup/popup';
import Spinner from '~/components/Spinner';
import store from '~/redux/user/store';
import { getLocalizedVal } from '~/tools/localization/helpers'
import { getUserPin, isParentalRatingSet } from '~/tools/isPinSet';
import { setParentalControls, updateRating } from '~/redux/user/actions';
import './style.scss'

class ViewingRestrictions extends Component {
   constructor(props) {
      super(props)
      this.state = {
         value: (this.props && this.props.user && this.props.user.parentalControl && this.props.user.parentalControl.parentalRating && this.props.user.parentalControl.parentalRating.rating) || (this.props && this.props.user && this.props.user.parentalControl && this.props.user.parentalControl.parentalRating) || "",
         checked: true
      }
      this.finalMsg = "";
    this.ratingSchema = {
        "All": {
          message: (this.props && this.props.args && this.props.args.localizedFields && this.props.args.localizedFields.args && this.props.args.localizedFields.args.allRatingMessage) || "All videos require a PIN", 
          label: (this.props && this.props.args && this.props.args.localizedFields && this.props.args.localizedFields.args && this.props.args.localizedFields.args.allRatingCategory) || "Kids"
        },
        "7+": {
          message: (this.props && this.props.args && this.props.args.localizedFields && this.props.args.localizedFields.args && this.props.args.localizedFields.args.sevenRatingMessage) || "Videos with these ratings require a PIN: 7+, 13+, 16+, 18+",
          label: (this.props && this.props.args && this.props.args.localizedFields && this.props.args.localizedFields.args && this.props.args.localizedFields.args.sevenRatingCategory) || "Older Kids"
        },
        "13+": {
          message: (this.props && this.props.args && this.props.args.localizedFields && this.props.args.localizedFields.args && this.props.args.localizedFields.args.thirteenRatingMessage) || "Videos with these ratings require a PIN: 13+, 16+, 18+",
          label: (this.props && this.props.args && this.props.args.localizedFields && this.props.args.localizedFields.args && this.props.args.localizedFields.args.thirteenRatingCategory) || "Teens"
        },
        "16+": {
          message: (this.props && this.props.args && this.props.args.localizedFields && this.props.args.localizedFields.args && this.props.args.localizedFields.args.sixteenRatingMessage) || "Videos with these ratings require a PIN: 16+, 18+",
          label: (this.props && this.props.args && this.props.args.localizedFields && this.props.args.localizedFields.args && this.props.args.localizedFields.args.sixteenRatingCategory) || "Young Adults"
        },
        "18+": {
          message: (this.props && this.props.args && this.props.args.localizedFields && this.props.args.localizedFields.args && this.props.args.localizedFields.args.eighteenRatingMessage) || "Videos with this rating require a PIN: 18+",
          label: (this.props && this.props.args && this.props.args.localizedFields && this.props.args.localizedFields.args && this.props.args.localizedFields.args.eighteenRatingCategory) || "Adults"
        }
      };
   }
   handleChange = (event) => {
      this.setState({value: event.target.value})
   }

   setRatingFirstTime = async (event) => {
      await event.preventDefault()
      this.setState({ processing: true})
      if(this.state.value) {
         let userRating = {
            "parentalRating": this.state.value
         }
         this.saveRating(userRating);
      }
      this.setState({ processing: false})
   }
   
   saveRating(userRating) {
      setParentalControls(userRating)
      .then(response => { 
         if (response && response.status === 200) {
            popup.hide()
            store.dispatch(updateRating(this.state.value))
         } else {
            this.alert(getLocalizedVal(window.settings,'genericMessages','unableSetPin') || 'Unable to set the PIN' || response.data.error);
            return false;
         }
      })
   }

   alert(msg) {
      this.setState({ error: msg })
      setTimeout(_ => this.setState({ error: null }), 8000)
   }

   render() {
      
      if(this.state.processing) {
         return <div className="loading-centered"><Spinner /></div>
      }
      const Args = this.props && this.props.args && this.props.args.localizedFields && this.props.args.localizedFields.args;
      this.finalMsg = this.state.value && this.ratingSchema[this.state.value]["message"] ? this.ratingSchema[this.state.value]["message"] : "Please choose any age to set restrictions";

      return (
         <div className="viewing-restrictions-container">
         <div className="centered padded">
            <div className="vr-margin-bottom"><h1>{(Args && Args.viewingRestrictionsCTA) || "Viewing Restrictions"}</h1></div>
            <div className="vr-margin-bottom vr-color-gray">
               {this.finalMsg}
            </div>
            <div className="vr-margin-bottom">{(Args && Args.tapAgeMessage) || "Tap age to set restrictions"}</div>
            <div className="vr-container">
               <label className="container">
                  <input type="radio" checked={this.state.value === "All" ? this.state.checked : false} name="radio" value="All" onChange={this.handleChange}/>
                  <span className={`checkmark` + (this.state.value === "All" ? " cta": "")} />
               </label>
               <div className="vr-flex vr-align-left">All</div>
               <div className="vr-flex vr-align-right">{(Args && Args.allRatingCategory) || "Kids"}</div>
            </div >
            <div className="vr-container">
               <label className="container">
                  <input type="radio" name="radio" value="7+" checked={this.state.value === "7+" ? this.state.checked : false} onChange={this.handleChange}/>
                  <span className={`checkmark` + (this.state.value === "7+" ? " cta": "")} />
               </label>
               <div className="vr-flex vr-align-left">7+</div>
               <div className="vr-flex vr-align-right">{(Args && Args.sevenRatingCategory) || "Older Kids"}</div>
            </div>
            <div className="vr-container">
               <label className="container">
                  <input type="radio" name="radio" value="13+" checked={this.state.value === "13+" ? this.state.checked : false} onChange={this.handleChange}/>
                  <span className={`checkmark` + (this.state.value === "13+" ? " cta": "")} />
               </label>
               <div className="vr-flex vr-align-left">13+</div>
               <div className="vr-flex vr-align-right">{(Args && Args.thirteenRatingCategory) || "Teens"}</div>
            </div>
            <div className="vr-container">
               <label className="container">
                  <input type="radio" name="radio" value="16+" checked={this.state.value === "16+" ? this.state.checked : false} onChange={this.handleChange}/>
                  <span className={`checkmark` + (this.state.value === "16+" ? " cta": "")} />
               </label>
               <div className="vr-flex vr-align-left">16+</div>
               <div className="vr-flex vr-align-right">{(Args && Args.sixteenRatingCategory) || "Young Adults"}</div>
            </div>
            <div className="vr-container">
               <label className="container">
                  <input type="radio" name="radio" value="18+" checked={this.state.value === "18+" ? this.state.checked : false} onChange={this.handleChange}/>
                  <span className={`checkmark` + (this.state.value === "18+" ? " cta": "")} />
               </label>
               <div className="vr-flex vr-align-left">18+</div>
               <div className="vr-flex vr-align-right">{(Args && Args.eighteenRatingCategory) || "Adults"}</div>
            </div>
            <div className="vr-save">
               <input type="submit" className= {`button cta` + (this.state.processing ? ' processing' : '')} value={(Args && Args.saveRatingCTA) || "SAVE"} onClick={(event)=> !isParentalRatingSet() ? (this.setRatingFirstTime(event)): (getUserPin() ? popup.pinOverlay({askPin: true,rating: this.state.value}) : popup.setupPin({localizedFields: getLocalizedVal(window.settings,'genericMessages','resetYourPin')}, {rating:this.state.value}))}/>
            </div>
         </div>
         </div>);
   }
}
export default ViewingRestrictions;